/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { useSelector } from 'react-redux'
import TableWithCheckbox from '@groovehq/internal-design-system/lib/components/TableWithCheckbox/TableWithCheckbox'
import { selectMailboxes } from 'selectors/mailboxes_base'
import useColumns from './useColumns'

const MailboxSelectionTable = ({
  onSelectedRowIdsChange,
  defaultSelectedRowIds,
}) => {
  const columns = useColumns()

  const mailboxes = useSelector(selectMailboxes)

  return (
    <TableWithCheckbox
      columns={columns}
      onSelectedRowIdsChange={onSelectedRowIdsChange}
      data={mailboxes}
      defaultSelectedRowIds={defaultSelectedRowIds}
    />
  )
}

export default MailboxSelectionTable
